export default {
  CLASSROOM: "classroom",
  KID_HOME: "kid (home)",
};
